import { createRouter, createWebHistory } from 'vue-router';
import MainContent from '../views/MainContent.vue';
import { RouteNames } from './routeNames';
import SocialLandingPage from '@/views/SocialLandingPage.vue';
import NotFound from '../components/NotFound.vue';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(_, _2, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
  routes: [
    {
      path: '/articles/:id',
      name: RouteNames.MAIN_CONTENT,
      component: MainContent,
      props: true,
    },
    {
      path: '/:country(us|ca)/:vanity/:smpostname',
      props: true,
      name: RouteNames.SOCIAL_LANDING_PAGE,
      component: SocialLandingPage,
    },
    {
      path: '/',
      alias: '/:pathMatch(.*)*',
      name: RouteNames.NOT_FOUND,
      component: NotFound,
    },
  ],
});

export default router;
